<template>
  <div class="step1">

    
    <!-- <PlateTitle title="投保信息" /> -->
    <a-spin :spinning="spinning">
      <!-- <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 10 }">
        <a-form-item label="投标人名称" has-feedback>
          <span>{{ dataSourceInfo.name }}</span>
        </a-form-item>
        <a-form-item label="投标人统一社会信用代码" has-feedback>
          <span>{{ dataSourceInfo.creditCode }}</span>
        </a-form-item>
        <a-form-item label="标段名称" has-feedback>
          <span>{{ dataSourceInfo.sectionName }}</span>
        </a-form-item>
        <a-form-item label="标段编号" has-feedback>
          <span>{{ dataSourceInfo.sectionCode }}</span>
        </a-form-item>
        <a-form-item label="担保金额" has-feedback>
          <span>{{ dataSourceInfo.sumAmount }} 元</span>
        </a-form-item>
        <a-form-item label="招标人名称" has-feedback>
          <span>{{ dataSourceInfo.tendereeName }}</span>
        </a-form-item>
        <a-form-item label="招标人统一社会信用代码" has-feedback>
          <span>{{ dataSourceInfo.tendereeCreditCode }}</span>
        </a-form-item>
      </a-form> -->
      
      <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 8 }">
        <PlateTitle title="选择机构" />

      <div>
        <a-form-item label="" has-feedback class="img_logo">
          <div class="select">
            <a-tabs v-model:activeKey="activeKey" @change="changeTab(activeKey)">
              <a-tab-pane key="3" tab="出函机构">
                <div class="list" 
                >
                  <span class="dbSpan" v-for="(item, index) in dataSource.institutions" :key="index" @click="activeIndex = item.id;dbListClick(item)">
                    <img  class="imgs" :src="'data:image/png;base64,'+item.logoPathBase64" />
                    <!-- <img  class="imgs" :src="'/api/contract/readFile?source='+item.logoPath" /> -->
                    <img v-if="activeIndex == item.id" class="suc" src="../../../assets/image/icon-cg.png" />
                  </span>
              </div>
              </a-tab-pane>
            </a-tabs>
          </div>
        </a-form-item>
        <a-form-item label="" has-feedback class="hide">
          <a-input
            v-decorator="[
              'institutionId',
            ]"
            placeholder="请输入"
            style="width: 280px"
          />
        </a-form-item>
        <a-form-item label="" has-feedback class="hide">
          <a-input
            v-decorator="[
              'institutionName',
            ]"
            placeholder="请输入"
            style="width: 280px"
          />
        </a-form-item>
      </div>
      <!-- <div v-else>
        <a-form-item label="出函机构" has-feedback class="img_logo">
          <div
            class="img_list"
            v-decorator="[
              'partnerCode',
              {
                rules: [
                  {
                    required: dataSourceInfo.partnerCode ? false : true,
                    message: '请点击选择'
                  }
                ]
              }
            ]"
          >
            <template v-for="item in logoArray">
              <div
                :id="dataSourceInfo.partnerCode ? 'cur' : 'no'"
                class="box"
                @click="handleClick(item)"
              >
                <div class="logo_box" :id="item.isTrue ? 'cur_i' : ''">
                  <img :src="item.logoPath" alt="" />
                </div>
              </div>
            </template>
          </div>
        </a-form-item>
      </div> -->
        <div class="Nocontent" v-if="dataSourceInfo.channelCode !== 'nmgzzq'&&dataSourceInfo.channelCode !== 'anqin'&&dataSourceInfo.channelCode !== 'nmgzzqXam'">
          <PlateTitle title="项目信息" />
          <a-form-item label="标段名称" has-feedback>
            <a-input
              v-decorator="[
                'sectionName',
                { rules: [{ required: true, message: '请输入' }] }
              ]"
              placeholder="请输入"
              style="width: 280px"
              disabled
            />
          </a-form-item>
          <a-form-item label="标段编号" has-feedback>
            <a-input
              v-decorator="[
                'sectionCode',
                { rules: [{ required: true, message: '请输入' }] }
              ]"
              placeholder="请输入"
              style="width: 280px"
              disabled
            />
          </a-form-item>
          <a-form-item label="项目名称" has-feedback>
            <a-input
              v-decorator="[
                'projectName',
                { rules: [{ required: true, message: '请输入' }] }
              ]"
              placeholder="请输入"
              style="width: 280px"
              disabled
            />
          </a-form-item>
          <a-form-item label="项目编号" has-feedback>
            <a-input
              v-decorator="[
                'projectCode',
                { rules: [{ required: true, message: '请输入' }] }
              ]"
              placeholder="请输入"
              style="width: 280px"
              disabled
            />
          </a-form-item>
          <a-form-item label="受益人" has-feedback>
            <a-input
              v-decorator="[
                'beneficiary',
                { rules: [{ required: true, message: '请输入' }] }
              ]"
              placeholder="请输入"
              style="width: 280px"
              disabled
            />
          </a-form-item>
          <a-form-item label="受益人统一社会信用代码" has-feedback>
            <a-input
              v-decorator="[
                'beneficiaryCreditCode',
                { rules: [{ required: true, message: '请输入' }] }
              ]"
              placeholder="请输入"
              style="width: 280px"
              
            />
          </a-form-item>
          <a-form-item label="受益人联系电话" has-feedback>
            <a-input
              v-decorator="[
                'beneficiaryPhone',
                { rules: [{ required: true,validator: compareToFirstPhone }] }
              ]"
              placeholder="请输入"
              style="width: 280px"
            />
          </a-form-item>
          <a-form-item label="受益人注册地址" has-feedback>
            <a-input
              v-decorator="[
                'beneficiaryRegisteredAddress',
                { rules: [{ required: true, message: '请输入' }] }
              ]"
              placeholder="请输入"
              style="width: 280px"
            />
          </a-form-item>
          <!-- <a-form-item label="保函产品" has-feedback>
            <el-select
              v-decorator="[
                  'product',
                  { rules: [{ required: true, message: '请输入' }] }
                ]"
              placeholder="请选择"
              class="nonBidSelect"
            >
              <el-option
                v-for="item in productList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </a-form-item> -->
          <a-form-item label="中标金额（元）" has-feedback>
            <a-input
              v-decorator="[
                'bidPrice',
                { rules: [{ required: true, message: '请输入' }] }
              ]"
              placeholder="请输入"
              style="width: 280px"
              disabled
            />
          </a-form-item>
          

          <a-form-item label="担保金额（元）" has-feedback>
            <a-input
              v-decorator="[
                'sumAmount',
                { rules: [{ required: true, message: '请输入' }] }
              ]"
              type="number"
              placeholder="请输入"
              style="width: 280px"
            />
          </a-form-item>
          <a-form-item label="担保类型" has-feedback>
            <el-select
              v-decorator="[
                  'guaranteePeriodType',
                  { rules: [{ required: true, message: '请输入' }] }
                ]"
              placeholder="请选择"
              class="nonBidSelect"
            >
              <el-option
                v-for="item in guaranteePeriodTypeList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </a-form-item>
          <a-form-item label="担保期限（月/天）" has-feedback
          v-if="form.getFieldValue('guaranteePeriodType') == 1||form.getFieldValue('guaranteePeriodType') == 2"
          >
            <a-input
              v-decorator="[
                'guaranteePeriod',
                { rules: [{ required: true, message: '请输入' }] }
              ]"
              type="number"
              placeholder="请输入"
              style="width: 280px"
            />
          </a-form-item>
          <a-form-item label="担保截止日期" has-feedback  
            v-else
          >
            <a-date-picker
              class="nonPicker"
              :locale="locale"
              v-decorator="[
                'guaranteeEndDate',
                { rules: [{ required: true, message: '请输入' }] }
              ]"
              placeholder="请输入"
              format="YYYY-MM-DD"
            />
          </a-form-item>
          <a-form-item label="是否已签署合同" has-feedback>
            <!-- <a-input
              v-decorator="[
                'isSignContract',
                { rules: [{ required: true, message: '请输入' }] }
              ]"
              placeholder="请输入"
              style="width: 280px"
            /> -->
            <el-select
              v-decorator="[
                  'isSignContract',
                  { rules: [{ required: true, message: '请输入' }] }
                ]"
              placeholder="请选择"
              class="nonBidSelect"
            >
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>

            </el-select>
          </a-form-item>
          <a-form-item label="合同工期（开始时间）" has-feedback>
            <a-date-picker
              class="nonPicker"
              :locale="locale"
              v-decorator="[
                'durationStartDate',
                { rules: [{ required: true, message: '请输入' }] }
              ]"
              placeholder="请输入"
              format="YYYY-MM-DD"
            />
          </a-form-item>
          <a-form-item label="合同工期（结束时间）" has-feedback>
            <a-date-picker
              class="nonPicker"
              :locale="locale"
              v-decorator="[
                'durationEndDate',
                { rules: [{ required: true, message: '请输入' }] }
              ]"
              placeholder="请输入"
              format="YYYY-MM-DD"
            />
          </a-form-item>
          <a-form-item label="项目性质" has-feedback>
            <el-select
              v-decorator="[
                  'projectNature',
                  { rules: [{ required: true, message: '请输入' }] }
                ]"
              placeholder="请选择"
              class="nonBidSelect"
            >
              <el-option
                v-for="item in projectNatureList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </a-form-item>
          <a-form-item label="最高等级资质" has-feedback>
            <el-select
              v-decorator="[
                  'maxAptitudeLevel',
                  { rules: [{ required: true, message: '请输入' }] }
                ]"
              placeholder="请选择"
              class="nonBidSelect"
            >
              <el-option
                v-for="item in maxAptitudeLevelList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </a-form-item>
          
          <!-- <a-form-item label="选择开票类型" has-feedback>
            <a-select
              v-decorator="[
                'invoiceType',
                { rules: [{ required: true, message: '请选择开票类型' }] }
              ]"
              placeholder="请选择开票类型"
              style="width: 280px"
              @change="handleChane"
            >
              <a-select-option
                v-for="(item, index) in typeArray"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="发票抬头" has-feedback>
            <a-input
              v-decorator="[
                'invoiceHead',
                { rules: [{ required: true, message: '请输入发票抬头' }] }
              ]"
              placeholder="请输入发票抬头"
              style="width: 280px"
            />
          </a-form-item>
          <a-form-item label="纳税人识别号" has-feedback>
            <a-input
              v-decorator="[
                'invoiceCuscCode',
                { rules: [{ required: true, message: '请输入纳税人识别号' }] }
              ]"
              placeholder="请输入纳税人识别号"
              style="width: 280px"
            />
          </a-form-item> -->
        </div>
        <PlateTitle title="企业信息" />
        <a-form-item label="企业名称" has-feedback>
          <a-input
            v-decorator="[
              'enterpriseName',
              { rules: [{ required: true, message: '请输入' }] }
            ]"
            placeholder="请输入"
            style="width: 280px"
            disabled
          />
        </a-form-item>
        <a-form-item label="企业统一社会信用代码" has-feedback>
          <a-input
            v-decorator="[
              'creditCode',
              { rules: [{ required: true, message: '请输入' }] }
            ]"
            placeholder="请输入"
            style="width: 280px"
            disabled

          />
        </a-form-item>
        <a-form-item label="注册地址" has-feedback>
          <a-input
            v-decorator="[
              'registeredAddress',
              { rules: [{ required: true, message: '请输入' }] }
            ]"
            placeholder="请输入"
            style="width: 280px"
          />
        </a-form-item>
        <a-form-item label="法人姓名" has-feedback>
          <a-input
            v-decorator="[
              'legalName',
              { rules: [{ required: true, message: '请输入' }] }
            ]"
            placeholder="请输入"
            style="width: 280px"
          />
        </a-form-item>
        <a-form-item label="联系方式" has-feedback>
          <a-input
            v-decorator="[
              'bidderPhone',
              { rules: [{ required: true,validator: compareToFirstPhone }] }
            ]"
            placeholder="请输入"
            style="width: 280px"
          />
        </a-form-item>
        <a-form-item label="经办人姓名" has-feedback>
          <a-input
            v-decorator="[
              'customerContact',
              { rules: [{ required: true, message: '请输入' }] }
            ]"
            placeholder="请输入"
            style="width: 280px"
          />
        </a-form-item>
        <a-form-item label="经办人电话" has-feedback>
          <a-input
            v-decorator="[
              'handlePhone',
              { rules: [{ required: true,validator: compareToFirstPhone }] }
            ]"
            placeholder="请输入"
            style="width: 280px"
          />
        </a-form-item>

        
      </a-form>
    </a-spin>
  </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import PlateTitle from "@/components/PlateTitle";
import {
  infoinformation,
  getSignUrl,
  startSign,
  code,
  phoneCode,
  // getList,
  getChannelInfo,
  getDictInfo,
  // getLastAccount
} from "@/api/nonBidInsure.js";
import { message } from "ant-design-vue";
import { dictDetail } from '@/api/performance.js';

export default {
  name: "Step1",
  components: {
    PlateTitle
  },
  props: {
    step: {
      type: Number,
      default: 0
    },
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    spinning: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      moment,
      locale,
      activeKey: '3',
      activeIndex: 0,
      uuid: "",
      codeImg: "",
      isTime: true,
      time: 60,
      form: this.$form.createForm(this, { name: "loginForm" }),
      orderCode: "",
      rules: {},
      readDocMap: "", // 已阅读并同意文件
      certTypeList: [], // 身份证件类型
      typeArray: [], //选择开票类型
      timeArray: [],
      logoArray: [],
      radioNum: null,
      bankList: [
        // require("../../../assets/info/b1.png"),
        // require("../../../assets/info/b2.png"),
        // require("../../../assets/info/b3.png"),
        // require("../../../assets/info/b4.png"),
        // require("../../../assets/info/b5.png"),
        // require("../../../assets/info/b6.png"),
        // require("../../../assets/info/b7.png"),
        // require("../../../assets/info/b8.jpg")
      ],
      bxList: [
        // require("../../../assets/info/bx1.jpg"),
        // require("../../../assets/info/bx2.jpg"),
        // require("../../../assets/info/bx3.jpg"),
        // require("../../../assets/info/bx4.jpg"),
        // require("../../../assets/info/bx5.jpg")
      ],
      dbList: [
        // '陕西文化产业融资担保',
        // require("../../../assets/info/db1.jpg")
      ],
      guaranteePeriodTypeList:[],
      projectNatureList:[],
      maxAptitudeLevelList:[],
      productList:[]
    };
  },
  computed: {
    dataSourceInfo() {
      console.log(this.dataSource, 99)
      // this.handlePreview( '/api/contract/readFile?source='+this.dataSource.institutions[0].logoPath)
      return this.dataSource;
    }
  },
  mounted() {
    this.getDictDetail()
    this.code();
  },
  methods: {
    getDictDetail() {
      dictDetail({ dictName: 'guaranteePeriodType' }).then(res => {
        this.guaranteePeriodTypeList = res.data.data;
      });
      dictDetail({ dictName: 'projectNature' }).then(res => {
        this.projectNatureList = res.data.data;
      });
      // 
      dictDetail({ dictName: 'maxAptitudeLevel' }).then(res => {
        this.maxAptitudeLevelList = res.data.data;
      });
      // dictDetail({ dictName: 'guaranteeAptitudeLevel' }).then(res => {
      //   this.guaranteeAptitudeLevelList = res.data.data;
      // });
      // dictDetail({ dictName: 'backletterFormat' }).then(res => {
      //   this.backletterFormatList = res.data.data;
      // });
      // dictDetail({ dictName: 'guaranteeProduct' }).then(res => {
      //   this.productList = res.data.data;
      // });
    },
    handleChane(e) {
      this.radioNum = e;
    },
    // 获取orderNo参数 调取已阅读接口
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    init(val) {
      this.form.setFieldsValue({
        // 赋值
        // invoiceType: this.dataSourceInfo.invoiceType,
        // invoiceHead: this.dataSourceInfo.invoiceHead?this.dataSourceInfo.invoiceHead:this.dataSourceInfo.basicAccountName,
        // invoiceCuscCode: this.dataSourceInfo.invoiceCuscCode?this.dataSourceInfo.invoiceCuscCode:this.dataSourceInfo.creditCode,
        // invoiceEmail: this.dataSourceInfo.invoiceEmail,
        // period: val ? this.dataSourceInfo.period : "",
        // mobile: this.dataSourceInfo.mobile,
        // partnerCode: this.dataSourceInfo.partnerCode,
        // addInfo: this.dataSourceInfo.addInfo,
        // bankInfo: this.dataSourceInfo.bankInfo,
        // bankAcc: this.dataSourceInfo.bankAcc,
        // addressee: this.dataSourceInfo.addressee,
        // addresseePhone: this.dataSourceInfo.addresseePhone,
        // address: this.dataSourceInfo.address,
        // tendereeName: this.dataSourceInfo.tendereeName,
        // tendereeCreditCode: this.dataSourceInfo.tendereeCreditCode,
        // invitationCode: this.dataSourceInfo.invitationCode,
        // responsiblePersonName: this.dataSourceInfo.responsiblePersonName,
        // code: '0000',
        sectionName: this.dataSourceInfo.sectionName,
        sectionCode: this.dataSourceInfo.sectionCode,
        projectName: this.dataSourceInfo.projectName,
        projectCode: this.dataSourceInfo.projectCode,
        beneficiary: this.dataSourceInfo.beneficiary,
        beneficiaryCreditCode: this.dataSourceInfo.beneficiaryCreditCode,
        beneficiaryPhone: this.dataSourceInfo.beneficiaryPhone,
        beneficiaryRegisteredAddress: this.dataSourceInfo.beneficiaryRegisteredAddress,

        bidPrice: this.dataSourceInfo.bidPrice,
        sumAmount: this.dataSourceInfo.sumAmount,
        guaranteePeriodType: this.dataSourceInfo.guaranteePeriodType,
        guaranteePeriod: this.dataSourceInfo.guaranteePeriod,
        guaranteeEndDate: this.dataSourceInfo.guaranteeEndDate,

        
        isSignContract: this.dataSourceInfo.isSignContract,
        durationStartDate: this.dataSourceInfo.durationStartDate,
        durationEndDate: this.dataSourceInfo.durationEndDate,
        projectNature: this.dataSourceInfo.projectNature,
        maxAptitudeLevel: this.dataSourceInfo.maxAptitudeLevel,

        enterpriseName: this.dataSourceInfo.enterpriseName,
        creditCode: this.dataSourceInfo.creditCode,
        registeredAddress: this.dataSourceInfo.registeredAddress,

        legalName: this.dataSourceInfo.legalName,
        bidderPhone: this.dataSourceInfo.bidderPhone,
        customerContact: this.dataSourceInfo.customerContact,
        handlePhone: this.dataSourceInfo.handlePhone,
        institutionId:this.dataSourceInfo.institutionId,
        institutionName:this.dataSourceInfo.institutionName,
      });
      setTimeout(() => {
        this.form.setFieldsValue({
          guaranteePeriod: this.dataSourceInfo.guaranteePeriod,
          guaranteeEndDate: this.dataSourceInfo.guaranteeEndDate,
        })
      }, 500);
      this.activeIndex = this.dataSourceInfo.institutionId
      if(!this.dataSourceInfo.institutionId){
        this.dataSourceInfo.institutions.map((item,index)=>{
          if(index == 0){
            this.activeIndex = item.id
            this.form.setFieldsValue({
              institutionId: item.id,
              institutionName: item.name,
            });
          }
        })
      }
      // if(this.dataSourceInfo.channelCode === 'nmgzzq'||this.dataSourceInfo.channelCode === 'hainan'||this.dataSourceInfo.channelCode === 'anqin'||this.dataSourceInfo.channelCode === 'nmgzzqXam') {
      //   this.form.setFieldsValue({
      //     responsiblePersonName:  this.dataSourceInfo.responsiblePersonName?  this.dataSourceInfo.responsiblePersonName : this.dataSourceInfo.principalName,
      //     basicAccountName: this.dataSourceInfo.basicAccountName,
      //     basicAccountNo: this.dataSourceInfo.basicAccountNo,
      //   })
      // }
      this.orderCode = this.getQueryString("orderCode");
      // 基本户银行获取
      // getLastAccount(this.orderCode).then(({ data: data }) => {
      //   if(data.data){
      //     this.dataSourceInfo.basicAccountNo = data.data
      //     this.form.setFieldsValue({
      //       basicAccountNo:this.dataSourceInfo.basicAccountNo
      //     })
      //   }
      // });

      // getChannelInfo({ orderCode: this.orderCode }).then(res => {
      //   this.readDocMap = res.data.readDocMap;
      //   this.timeArray = res.data.effectiveTime;
      //   this.form.setFieldsValue({
      //     period: this.dataSourceInfo.period ? this.dataSourceInfo.period : this.timeArray[0].value
      //   })
      // });
      // getDictInfo("invoiceType").then(({ data: data }) => {
      //   this.typeArray = data.data;
      // });
      // getList({ orderCode: this.orderCode }).then(({ data: data }) => {
      //   this.logoArray = data.data;
      //   data.data.map(item=>{
      //     if(item.partnerType == '1'){
      //       this.dbList.push(item)
      //     } else if(item.partnerType == '2'){
      //       this.bxList.push(item)
      //     } else if(item.partnerType == '3'){
      //       this.bankList.push(item)
      //     }
      //   })
      //   if(this.dataSourceInfo.channelCode !== 'hainan' && this.dataSourceInfo.channelCode !== 'nmgzzq'&& this.dataSourceInfo.channelCode !== 'anqin'&& this.dataSourceInfo.channelCode !== 'nmgzzqXam') {
      //     this.form.setFieldsValue({
      //       partnerCode: this.dbList[0].partnerCode
      //     });
      //   }else{
      //     this.form.setFieldsValue({
      //       partnerCode: this.dbList[0].partnerCode
      //     });
      //   }
      // });
    },
    dbListClick(item){
      this.form.setFieldsValue({
        institutionId: item.id,
        institutionName: item.name,
      });
      this.$forceUpdate();
    },
    /* 图片验证码 */
    code() {
      code().then(res => {
        this.codeImg = res.data.img;
        this.uuid = res.data.uuid;
      });
      this.orderCode = this.getQueryString("orderCode");
      // getChannelInfo({ orderCode: this.orderCode }).then(res => {
      //   this.timeArray = res.data.effectiveTime;
      // });
    },
    /* 获取验证码 */
    phoneCode() {
      this.timer = "";
      if (
        this.form.instances.mobile.stateValue !== "" &&
        this.form.instances.code.stateValue !== ""
      ) {
        phoneCode({
          codeKey: this.uuid,
          code: this.form.instances.code.stateValue,
          phoneNum: this.form.instances.mobile.stateValue
        }).then(({ data: data }) => {
          // console.log('---res',data);
          if (data.status === 200) {
            this.isTime = false;
            this.timer = setInterval(this.countDown, 1000);
          }
        });
      } else {
        this.$message.warning("手机号码和图形验证码不为空");
      }
    },
    countDown() {
      if (this.time > 0) {
        this.time--;
      } else {
        this.time = 60;
        this.isTime = true;
        clearInterval(this.timer);
      }
    },

    // 自定义校验
    basicAccountName(rule, value, callback) {
      if (value === "" || !value) {
        callback("请输入基本户户名");
      } else {
        callback();
      }
    },
    basicAccountNo(rule, value, callback) {
      if (value === "" || !value) {
        callback("请输入基本户银行账号");
      } else {
        callback();
      }
    },
    responsiblePersonName(rule, value, callback) {
      if (value === "" || !value) {
        callback("请输入经办人姓名");
      } else {
        callback();
      }
    },
    compareToFirstPhone(rule, value, callback) {
      const pattern = /^1[3|4|5|7|8|9][0-9]{9}$/;
      if (pattern.test(value) && value) {
        callback();
      } else {
        callback("请输入正确的手机号");
      }
    },
    compareToFirstCode(rule, value, callback) {
      if (value === "" || !value) {
        callback("请输入图形验证码");
      } else {
        callback();
      }
    },
    compareToFirstPhcode(rule, value, callback) {
      if (value === "" || !value) {
        callback("请输入短信验证码");
      } else {
        callback();
      }
    },

    getEmail(rule, value, callback) {
      const pattern = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (pattern.test(value) && value) {
        callback();
      } else {
        callback("请输入正确电子邮箱");
      }
    },

    // 点击选中
    handleClick(item) {
      debugger
      if (this.dataSourceInfo.partnerCode) return;
      this.form.setFieldsValue({
        partnerCode: item.partnerCode
      });
      this.logoArray.forEach(items => {
        items.isTrue = false;
      });
      this.$set(item, "isTrue", !item.isTrue);
      this.$forceUpdate();
    },

    changeTab (changeTab) {
      // console.log(changeTab)
      // this.activeIndex = 0
      // if(changeTab == '3'){
      //   this.form.setFieldsValue({
      //     partnerCode: this.dbList[0].partnerCode
      //   });
      // }
      // if(changeTab == '2'){
      //   this.form.setFieldsValue({
      //     partnerCode: this.bxList[0].partnerCode
      //   });
      // }
      // if(changeTab == '1'){
      //   this.form.setFieldsValue({
      //     partnerCode: this.bankList[0].partnerCode
      //   });
      // }
    },
    downloadFile(url) {
      return new Promise((resolve, reject) => {
        // 对于IE使用XHR，其他浏览器可以使用fetch
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        
        xhr.onload = function() {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('文件下载失败'));
          }
        };
        
        xhr.onerror = function() {
          reject(new Error('网络错误'));
        };
        
        xhr.send();
      });
    },
    async handlePreview(url) {
      try {
        // 1. 下载文件
        const blob = await this.downloadFile(url);
        
        // 2. 转换为Base64
        this.previewImage = await this.blobToBase64(blob);
      } catch (error) {
        console.error('预览失败:', error);
      }
    },
    // Blob转Base64方法
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        reader.onload = () => {
          resolve(reader.result);
        };
        
        reader.onerror = reject;
        
        // IE兼容性处理
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // IE特殊处理
          reader.readAsDataURL(blob);
        } else {
          // 标准浏览器处理
          reader.readAsDataURL(blob);
        }
      });
    }
    
  }
};
</script>

<style lang="less" scoped>
.step1 {
  .img_logo {
    .img_list {
      display: flex;
      flex-wrap: wrap;
      .box {
        margin-right: 10px;
      }
    }
    #cur {
      cursor: no-drop;
    }
    #no {
      cursor: pointer;
    }
    #cur_i {
      border: 2px solid #1890ff;
    }
    .logo_box {
      width: 100%;
      height: 94px;
      border: 1px solid #8b8b8b;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .money {
      font-size: 22px;
      color: #d9001b;
    }
  }


  .Nocontent{
  }
  /deep/ .ant-row {
    display: inline-block;
    //margin-left: 15%;
    // justify-content: center;
  }

  .hrefa {
    // color: #666
    color: #1890ff;
  }

  .code {
    img {
      position: absolute;
      cursor: pointer;
      left: 185px;
      top: -6px;
      height: 28px;
    }

    a,
    span {
      position: absolute;
      width: 97px;
      left: 190px;
    }
  }
}

.palnList {
  display: flex;
  flex-wrap: wrap;

  .palnListBox {
    display: flex;
    // flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 425px;
    height: 80px;
    margin-bottom: 20px;
    position: relative;
    background: #ffffff;
    border: 2px solid #d2e1ec;
    border-radius: 4px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #6a95b5;
    margin-right: 30px;
    cursor: pointer;
    // padding-left: 25px;
    transition: all 0.5s;

    .palnText {
      margin: 20px 0 0 17px;

      span {
        font-size: 16px;
        font-weight: bold;
      }

      p {
        font-size: 14px;
      }
    }

    img {
      // width: 330px;
      // height: 75px;
      height: 74px;
    }

    .feilv {
      position: absolute;
      text-align: center;
      top: -2px;
      right: -2px;
      width: 60px;
      height: 20px;
      background: #f83333;
      border-radius: 0px 4px 0px 10px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .palnListBoxAct {
    border: 2px solid #36a4ff;
    background: linear-gradient(-30deg, #e6f3fd 0%, #ffffff 100%);
    color: #007ce2;
    transition: all 0.5s;
  }
}

.content {
  margin-left: 15%;
}

.tit {
  font-size: 18px;
  font-weight: 500;
  margin: 20px 0;
}

.title {
  font-size: 16px;
  font-weight: 600;
  margin: 30px 0 0px 0px;

  span {
    font-size: 14px;
    font-weight: 300;
    padding-left: 10px;
    color: black;
  }
}

::v-deep .ant-form-item-control {
  margin-left: 0px;
  width: 400px;
  word-wrap: break-word;
}
.img_logo ::v-deep .ant-form-item-control {
  width: 1180px;
}
::v-deep .ant-form-item-label {
  text-align: left;
}

.items {
  margin-left: 0 !important;

  ::v-deep .ant-form-item-control {
    margin-left: 0 !important;
  }

  ::v-deep .ant-col {
    height: 30px;
  }

  ::v-deep .ant-upload-list-item-card-actions .anticon {
    display: none;
  }
}

.items2 {
  margin-left: 0 !important;

  ::v-deep .ant-form-item-control {
    margin-left: 0 !important;
    width: 260px;
  }

  ::v-deep .ant-col {
    height: 30px;
  }
}

.plastDialog2 {
  ::v-deep .ant-modal-footer {
    display: none;
  }
}

.formItem {
  ::v-deep .ant-form-item-label {
    padding-left: 11px;
  }
}

.requiredUpload {
  position: absolute;
  left: -280px;
  top: 13px;
  margin-right: 4px;
  color: #f5222d;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
}

.sgin {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
::v-deep .hide {
  display: none !important;
}
.list {
  span {
    width: 185px;
    height: 80px;
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    position: relative;
    cursor: pointer;
    img {
      width: 180px;
      height: 80px;
    }
    .suc {
      position: absolute;
      right: 3px;
      top: 3px;
      width: 16px;
      height: 16px;
    }
  }
  .dbSpan {
    width: 185px;
    border: 1px solid #8b8b8b;
    line-height: 80px;
    height: 80px;
    text-align: center;
    border-radius: 5px;
    font-weight: bold;
    .imgs {
      height: 80px;
      position: relative;
      top: -2px;
    }
  }
  .dbSpanhcjs{
    height: 136px;
    .imgs {
      height: 80px;
      position: relative;
      top: -2px;
    }
  }
  .mb10 {
    margin-bottom: 10px;
  }
}
.list .tipA{
  width: 14px;
  height: 14px;
  background: linear-gradient( 270deg, #5DAEFF 0%, #0E52D4 100%);
  border-radius: 50%;
  transform: translateY(6px);
}
.tip {
  color: red;
  font-size: 12px;
  position: absolute;
  top: -10px;
  left: 290px;
  width: 300px;
}
.list .dbSpanhcjsP{
  width: 182px;
  height: 50px;
  background: #F0F6FF;
  border-radius: 0px 0px 4px 4px;
  margin:0!important;
  padding:0!important;
  display: block!important;
  padding-left: 5px!important;
}
.list .dbSpanhcjsPone{
  height: 25px;
  margin:0!important;
  display: block!important;
  padding:0!important;
  line-height: 25px!important;
  text-align: left;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 11px;
  color: #666666;
  
} 
::v-deep .ant-col-6 {
  width: 190px;
}
.nonBidSelect ::v-deep  .el-input--suffix .el-input__inner{
  width: 280px;
  height: 32px;
}

.nonPicker ::v-deep .ant-calendar-picker-input {
  width: 280px;

}
</style>
